import { FontFamily } from '@euler/components/typography/fonts';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { StyleProp, Text, ViewStyle } from 'react-native';

export const Heading = memo(
  ({
    text,
    numberOfLines,
    style,
    allowFontScaling,
    adjustsFontSizeToFit,
  }: {
    text: string;
    numberOfLines?: number;
    style?: StyleProp<ViewStyle>;
    allowFontScaling?: boolean;
    adjustsFontSizeToFit?: boolean;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <Text
        allowFontScaling={allowFontScaling}
        adjustsFontSizeToFit={adjustsFontSizeToFit}
        numberOfLines={numberOfLines}
        css={`
          font-family: ${FontFamily.NotoSans.Medium};
          font-size: ${rpx(18)}px;
          margin-bottom: ${rpx(16)}px;
        `}
        style={style}
      >
        {text}
      </Text>
    );
  },
);
